// extracted by mini-css-extract-plugin
export default {"inputWrapper":"PopupAddQuestion_inputWrapper__ifege"};